/* global define */
define('modules/videos/teal/teal-wrapper',[
    'jquery',
    'underscore',
    'baseview',
    'modules/videos/teal/teal-sp',
    'managers/autoplay',
    'utils',
    'state',
    'admanager',
    'modules/videos/pluto/pluto-title-bar',
    'pubsub'

],
function(
    $,
    _,
    BaseView,
    TealSP,
    AutoPlayManager,
    Utils,
    StateManager,
    AdManager,
    PlutoTitleBar,
    PubSub

){
    'use strict';
    var TealWrapper = BaseView.extend({
        initialize: function(options) {
            options = $.extend({
                analytics: {
                    clickedClose: 'teal-dockedplayerclosed'
                }
            }, options);
            BaseView.prototype.initialize.call(this, options);

            this.playerReady = $.Deferred();
            this.adFree = AdManager.isAdFreeExperience();
            this.pageInfo = StateManager.getActivePageInfo();
            this.tealAdsEnabled = !(this.adFree && this.pageInfo.adsEnabled);
            this.video = this.buildData(this.$('.ui-video-data'));  /* get video data */
            this.placement = this.buildData(this.$('.ui-video-placement-data'));  /* Get placement data */
            this.autoPlay = this.placement.uwAutoplay && !this.adFree;
            window.VideoCount = window.VideoCount || 0;
            this._bidderId = this.$el.data().slotId; /* Set for mapping prebid responses */

            // Load CSS and scripts once
            if (!window.Teal) {
                $('head').append('<link rel="stylesheet" href="' + Utils.getNested(window.site_vars, 'html5video', 'teal', 'playerStyles') + '" type="text/css" />');
                Utils.loadScript(Utils.getNested(window.site_vars, 'html5video', 'teal', 'playerScript'), 'Teal').then(_.bind(function() {
                    this._setTealPlayerData();
                }, this));
            }

           _.bindAll(this, '_startAutoPlay', '_setTealPlayerData', '_initializeTealPlayer', '_onStateChange', '_subscribe');

           // Register autoplay
            if (this.autoPlay) {
                AutoPlayManager.register('pluto-video', this._startAutoPlay);
            }
        },

        _setTealPlayerData: function () {
            var userInsights = this._getUserInsights(),
                sstsObj = this.pageInfo.ssts.split('/');

            this.pData = {
                adTargeting: {
                    customParams: {},
                    simpleTarget: window.simpleTarget ? window.simpleTarget : []
                },

                // page meta
                awsPath: this.pageInfo.cst,
                baseName: Utils.getNested(window.site_vars, 'site_key'),
                displayName: Utils.getNested(window.site_vars, 'display_name'),
                id: Utils.getNested(window.site_vars, 'siteid'),
                keywords: this.pageInfo.topic,
                pageType: this.pageInfo.basePageType,
                publicationName: Utils.getNested(window.site_vars, 'display_name'),
                section: this.pageInfo.section_name,
                series: this.pageInfo.series || '',
                siteCode: Utils.getNested(window.site_vars, 'site_code'),
                subsection: sstsObj[1] || '',
                subtopic: sstsObj[3] || '',
                topic: sstsObj[2] || '',

                // Third party initialization 
                twitter: Utils.getNested(window.site_vars, 'twitter', 'default_account'),

                // User data
                anonymousId: '',
                benefitSegment: userInsights.benefitSegment || '',
                clientID: '',
                cohort: userInsights.cohort || '',
                dynamicPaywallSegments: '',
                fireflyUserId: '',
                userLicenseType: 'none',
                userMeterState: 'nothitpaywall',
                userScroll: 'none',
                userType: ''
            };

            // initialize after all data is set
            this._initializeTealPlayer();

            /**
             * Initialize scrolling player
             */
            if (this.placement.scrollingplayer && !this.adFree) {
                if (Utils.getNested(window.site_vars, 'html5video', 'scrollingPlayer', 'docked')) {
                    this.sp = new TealSP({
                        el: this.$el,
                        pauseAfterBuffer: _.bind(this.pauseAfterBuffer, this),
                        placement: this.placement,
                        tealPlayer: this.tealPlayer,
                        video: this.video
                    });
                }
            }

        },

        _initializeTealPlayer: function () {

             // Initialize teal player 
            this.tealPlayer = new window.Teal.Player(
                {
                    video: this.$('video')[0],
                    container: this.$('.teal-video-wrap')[0],
                    adContainer: this.$('.tealplayer-ad-container')[0]
                },
                {
                    base: {
                        debug: true, // will only work with debug script version
                        placement: 'teal-' + this.placement.name,
                        startedBy: this.autoPlay ? 'auto-first' : 'user',
                        startMuted: this.autoPlay

                    },
                    ias: {enable: this.tealAdsEnabled},
                    ima: { 
                        enable: this.tealAdsEnabled,

                        // site specific settings
                        accountId: Utils.getNested(window.site_vars, 'ADS', 'DFP', 'ACCOUNTID'),
                        accountName: Utils.getNested(window.site_vars, 'ADS', 'DFP', 'ACCOUNTNAME'),
                        mobileAccountName: Utils.getNested(window.site_vars, 'ADS', 'DFP', 'ACCOUNTNAME'),
                        mobilePlacement: 'preroll-video',

                        // adPlus ads
                        adPlusEnabled: Utils.getNested(this.placement, 'unlimitedAds', 'enabled'),
                        adPlusCampaign: Utils.getNested(this.placement, 'unlimitedAds', 'campaign') || 'continousplus1',
                        adPlusMaxFailures: Utils.getNested(this.placement, 'unlimitedAds', 'maxFailures') || 3,
                        adPlusMaxRequests: Utils.getNested(this.placement, 'unlimitedAds', 'maxRequests') || 2,
                        adPlusRequiredPlays: Utils.getNested(this.placement, 'unlimitedAds', 'requiredPlays') || 0,
                        targetingConsent: window.privacyConfig && window.privacyConfig.isCcpaSubject && window.privacyConfig.targeting === false ? false : true,
                        prebidBids: this._getPrebidResponse()
                    },
                    comscore: {enable: true},
                    heartbeat: {
                        enable: false,
                        load: false
                    },
                    hls: {
                        enable: true,
                        excludeRenditions: Utils.getNested(this.placement, 'hls', 'excludeRenditions') || false
                    },
                    controls: {
                        enable: true,
                        enableBigPlayButton: true
                    },
                    continuousPlay: {
                        encore: this.tealAdsEnabled
                    },
                    parsely: {
                        enable: Utils.getNested(window.site_vars, 'THIRDPARTYAPI', 'parsely', 'enabled') || false
                    }
                },
                this.pData,
                this.video
            );

            this._subscribe();

            if (this.placement.name.indexOf('automatedvideoplayer') > -1 && !this.adFree) {
                this.avp = true;
                this.initializeAVPPlayer();
            }
        },

        /**
         * Builds the data passed from html element
         * @returns {Object}
         */
        buildData: function(dom) {
            var data = dom.html() || {};
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            return data;
        },

        _getPrebidResponse: function () {
            if (window.pbjs && window.pbjs.getBidResponsesForAdUnitCode) {
                var bidContainer = window.pbjs.getBidResponsesForAdUnitCode(this._bidderId);
                return Utils.getNested(bidContainer, 'bids');
            }
        },

        _getUserInsights: function() {
            var data = {};
            try {
                data = JSON.parse(window.localStorage.getItem('user_insights')) || {};
            } catch(e) {
                // user_insights not a json string
            }
            return data;
        },

        _onStateChange: function (stateObj) {
            switch (stateObj.state) {
                case this.tealPlayer.sm.states.READY:
                    // Resolve on video or ad Ready
                    this.playerReady.resolve();
                    break;
                case this.tealPlayer.sm.states.PLAYING:
                    if (this.forcedPaused) {
                        this.tealPlayer.pause();
                        this.forcedPaused = false;
                    }
                    break;
            }
        },

        pauseAfterBuffer: function () {
            this.forcedPaused = true;
        },

        _startAutoPlay: function () {
            return this.playerReady.done(_.bind(function() {
                if (this.avp && this.$el) {
                    this.$el.removeClass('automatedvideoplayerhidden');
                }
                this.tealPlayer.play(); // call play on video.
                return true;
            }, this));
        },

        _subscribe: function () {
            this.tealPlayer.sm.subscribe(this.tealPlayer, {
                STATE: this._onStateChange,
                EVENT: this._onEvent.bind(this)
            });
        },

        _onEvent: function(event) {
            if (event === 'timeChange') {
                var currentTime = this.tealPlayer.currentTime,
                    roundoffCurrentTime = Math.round(currentTime),
                    vidLength = this.tealPlayer.duration;
                this.tealPlayer.settings.ima.prebidBids = [];
                if (this.tealPlayer.settings.ima.enable && (vidLength <= 15 || roundoffCurrentTime >= vidLength - 10)) {
                    window.pbjs.que.push(_.bind(function() {
                        window.pbjs.requestBids({
                            timeout: Utils.getNested(window.site_vars, 'ADS', 'prebid', 'timeout') || 1500,
                            adUnitCode: this._bidderId,
                            bidsBackHandler: _.bind(function (bids) {
                                this.tealPlayer.settings.ima.prebidBids = bids;
                            }, this)
                        });
                    }, this));
                }
            }
        },

        initializeAVPPlayer: function () {
            // TODO docked player workings
            if (Utils.getNested(window.site_vars, 'html5video', 'scrollingPlayer', 'titleBar')) {
                this.subviews.tb = new PlutoTitleBar({
                    el: this.$('.js-ptb'),
                    onClose: _.bind(this.onAVPClose, this)
                });
            }
            this.$el.addClass('playerIsScrolling');
            this.subviews.tb.show();
        },

        onAVPClose: function() {
            PubSub.trigger('uotrack', this.options.analytics.clickedClose);
            this.el.parentNode.removeChild(this.el);
            this.destroy();
        },

        /**
         * Destroys the view
         */
        destroy: function () {
            BaseView.prototype.destroy.apply(this, arguments);
        }
    });

    return TealWrapper;
});

